import React from "react";
import useIntervention from "./useIntervention";

// move these to a separate file and import if you use them elsewhere
const fields = {
  programmed: [
    { id: "yes", name: "Προγραμματισμένο" },
    { id: "no", name: "Μη προγραμματισμένο" },
  ],
  category: [
    { id: "croad", name: "Κλειστός δρόμος" },
    { id: "cline", name: "Κλειστή λωρίδα" },
    { id: "roadjobs", name: "Οδικές εργασίες" },
    { id: "roadworks", name: "Οδικά έργα" },
    { id: "roadblock", name: "Φραγμός δρόμου" },
    { id: "roadflood", name: "Πλημμυρισμένος δρόμος" },
    { id: "roadaccident", name: "Ατύχημα δρόμου" },
    { id: "roadincident", name: "Συμβάν δρόμου" },
  ],
  type_of_code: [
    { id: "extented", name: "Εκτεταμένης κλίμακας" },
    { id: "roadcorrection", name: "Διαγράμμιση οδοστρώματος" },
    { id: "slowmaintenance", name: "Αργά κινούμενες εργασίες συντήρησης" },
    { id: "fastmaintenance", name: "Γρήγορες εργασίες συντήρησης" },
    { id: "sortfixedfield", name: "Βραχυπρόθεσμες εργασίες σταθερού πεδίου" },
    { id: "cleanroad", name: "Εργασίες καθαρισμού οδού" },
    { id: "wintermaintenance", name: "Εργασίες χειμερινής συντήρησης" },
  ],
  status: [
    { id: "proposal", name: "Πρόταση" },
    { id: "study", name: "Μελέτη" },
    { id: "ongoing", name: "On going" },
    { id: "closed", name: "Κλειστό" },
  ],
};

const categorySub = [
  {
    id: "maintenance",
    name: "Συντήρηση",
    subcategories: [
      { id: "sub1", name: "Εργασίες συντήρησης κατακόρυφης/οριζόντιας σήμανσης" },
      { id: "sub2", name: "Κλάδεμα φυτεύσεων" },
      {
        id: "sub3",
        name: "Διατάξεις ανάσχεσης ταχύτητας (ανακλαστήρες, ακουστικές λωρίδες)",
      },
      {
        id: "sub4",
        name: "Τοποθέτηση πεζοφάναρου/Αναλάμπων κίτρινος φανός πεζών",
      },
      { id: "sub5", name: "Ηλεκτρονικός εξοπλισμός Διαβάσεων" },
      { id: "sub6", name: "Αποκατάσταση φθορών οδοστρώματος" },
      { id: "sub7", name: "Άλλες παρεμβάσεις συντήρησης" },
    ],
  },
  {
    id: "study",
    name: "Έργο",
    subcategories: [
      { id: "sub1", name: "Κυκλικός κόμβος" },
      { id: "sub2", name: "Νησίδα" },
      { id: "sub3", name: "Διάβαση πεζών" },
      { id: "sub4", name: "Υπέργεια διάβαση" },
      { id: "sub5", name: "Διαπλάτυνση δρόμου" },
      { id: "sub6", name: "Κατασκευή εσοχής" },
      { id: "sub7", name: "Άλλες υποδομές" },
      { id: "sub8", name: "Φωτεινή σηματοδότηση" },
      { id: "sub9", name: "Κυκλοφοριακές ρυθμίσεις" },
      { id: "sub10", name: "Άλλη κατασκευή" },
    ],
  },
  {
    id: "tech",
    name: "Τεχνολογική παρέμβαση",
    subcategories: [
      { id: "sub1", name: "Κάμερες αστυνόμευσης" },
      { id: "sub2", name: "Κάμερες παρακολούθησης κυκλοφορίας" },
      { id: "sub3", name: "Αισθητήρες κυκλοφορίας" },
      { id: "sub4", name: "Έξυπνη σηματοδότηση" },
      { id: "sub5", name: "Πινακίδες μεταβλητών μηνυμάτων" },
      { id: "sub6", name: "Εφαρμογή C-ITS" },
      { id: "sub7", name: "Άλλη τεχνολογία" },
    ],
  },
];

// helpers to map ids -> labels
const getCategoryLabel = (categoryId) => {
  if (!categoryId) return "Unknown";
  const cat = categorySub.find((c) => c.id === categoryId);
  return cat?.name || "Unknown";
};

const getSubcategoryLabel = (categoryId, subcategoryId) => {
  if (!categoryId || !subcategoryId) return "Unknown";
  const cat = categorySub.find((c) => c.id === categoryId);
  const sub = cat?.subcategories.find((s) => s.id === subcategoryId);
  return sub?.name || "Unknown";
};

const formatDateTime = (ts) => {
  if (!ts) return "Unknown";
  const d = new Date(ts);
  if (isNaN(d.getTime())) return ts;
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

const useInterventionTable = (counter) => {
  const { data = [], loading, error } = useIntervention(counter);
  //console.log("intervention data:", data);

  const columns = [
    { Header: "Id", accessor: "id" },
    { Header: "Κατηγορία", accessor: "categoryLabel" },
    { Header: "Υποκατηγορία", accessor: "subcategoryLabel" },
    { Header: "Κατάσταση Παρέμβασης", accessor: "statusLabel" },
    { Header: "Cluster Id", accessor: "clusterId" },
    { Header: "Description", accessor: "description" },
    { Header: "Δημιουργία", accessor: "createdAt" },
  ];

  const rows = data.map((item) => ({
    id: item.id ?? "Unknown",
    categoryLabel: item.category.name || "Unknown",
    subcategoryLabel: item.subcategory.name || "Unknown",
    statusLabel: item.status.name || "Unknown",
    clusterId: item.clusterId ?? "",
    description: item.description ?? "",
    file: item.file ?? null,
    createdAt: formatDateTime(item.createdAt),
  }));

  return {
    tableData: { columns, rows },
    loading,
    error,
  };
};

export default useInterventionTable;
